import { useEffect, useMemo } from "react";
import { useStore } from "../state/store";
import { moment } from "../play/celebrate";

const COINS = 28;

/** A win in gold, a bust in red: shown once over everything, gone in a breath. */
export function Moment() {
  const now = useStore(moment);
  useEffect(() => {
    if (!now) return;
    const timer = setTimeout(() => moment.set((held) => (held?.id === now.id ? null : held)), now.kind === "win" ? 2_600 : 1_200);
    return () => clearTimeout(timer);
  }, [now]);
  // each coin's flight, fixed for the moment
  const coins = useMemo(
    () =>
      Array.from({ length: COINS }, (_, i) => ({
        x: Math.round((Math.random() - 0.5) * 900),
        y: Math.round(-200 - Math.random() * 420),
        r: Math.round((Math.random() - 0.5) * 720),
        d: Math.round(Math.random() * 180),
        s: 0.6 + Math.random() * 0.7,
        i,
      })),
    // a new set for each moment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [now?.id],
  );
  if (!now) return null;
  if (now.kind === "bust") return <div className="moment moment-bust" key={now.id} aria-hidden />;
  return (
    <div className="moment moment-win" key={now.id} role="status">
      <div className="moment-coins" aria-hidden>
        {coins.map((coin) => (
          <span
            key={coin.i}
            className="moment-coin"
            style={{
              ["--x" as string]: `${coin.x}px`,
              ["--y" as string]: `${coin.y}px`,
              ["--r" as string]: `${coin.r}deg`,
              ["--s" as string]: coin.s,
              animationDelay: `${coin.d}ms`,
            }}
          />
        ))}
      </div>
      <div className="moment-card">
        <span className="moment-word">Winner</span>
        {now.multiple && <span className="moment-mult num">{now.multiple}</span>}
        <span className="moment-amount num">{now.amount}</span>
      </div>
    </div>
  );
}
